import { DefaultModel } from 'src/app/core/framework/default.model';
import { DefaultFilter } from '../../../core/framework/default-service.interface';
import { TipoPerfilDeAcesso } from './tipo-perdil-de-acesso.enum';


export interface PerfilDeAcessoFilter extends DefaultFilter {
  nome?: string;
}

export class PerfilDeAcesso extends DefaultModel {
  static ID_PERFIL_ACESSO_ADMINISTRADOR = 1;
  static ID_PERFIL_ACESSO_INTEGRACAO = 3;

  nome: string;
  tipoPerfil: TipoPerfilDeAcesso;

}
